export const getDxAiPatientClinicMuiDialogTitle = (palette: any) => ({
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        padding: "1.5rem 1.5rem 1rem 1.5rem",
      },
    },
  },
});
